var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitch = function SvgTwitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 2a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v12a1 1 0 0 1-.293.707l-4 4A1 1 0 0 1 17 19h-4.586l-3.707 3.707A1 1 0 0 1 7 22v-3H3a1 1 0 0 1-1-1zm2 1v14h4a1 1 0 0 1 1 1v1.586l2.293-2.293A1 1 0 0 1 12 17h4.586L20 13.586V3zm7 3a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1m5 0a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
};
export default SvgTwitch;